module.exports = __webpack_public_path__ + "img/p3.db0a865.jpg";